import * as angular from 'angular';

export const MassiaTabulatorModule = angular.module('massia.tabulator', ['pascalprecht.translate', 'ui.router']);
